<template>
    <div>
        <Table border :loading="loading" :columns="columns" :data="data"> </Table>
        <div style="margin:20px 0;">
            <Page style="float: right" :total="total" @on-change="pageChange"/>
        </div>
    </div>
</template>

<script>
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            date: new DateUtil(),
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Approver'),/* 审批人 */
                    key: "approvalName",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true
                },{
                    title: this.$t('Approval_Time'),/* 审批时间 */
                    key: "approvalDate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true
                },{
                    title: this.$t('Approval_Decision'),/* 审批决定 */
                    key: "decision",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },{
                    title: this.$t('Approval_opinions'),/* 审批意见 */
                    key: "idea",
                    align: "center",
                    minWidth: 120,
                    ellipsis:false,
                },
            ]
        }
    },
    methods:{
        pageChange(val){
            this.pageInfo.pageNo = val
            this.$emit('pageChangeApproval',this.pageInfo)
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/ApprovalHistory.vue